import { useEffect, useRef, useState } from "react";
import { previewPrompt } from "../../services/guides";
import type { CharacterProfile } from "../../types/guide";

// Shows ONLY the guide-specific prompt. The fixed system-wide rules (safety
// core, memory/tool conduct) are composed in by the backend template but are
// deliberately hidden here — system boilerplate confuses companion authors.
export function PromptPreview({ profile }: { profile: CharacterProfile }) {
  const [prompt, setPrompt] = useState<string>("Select or edit a companion…");
  const timer = useRef<number | undefined>(undefined);

  useEffect(() => {
    if (!profile.name && !profile.personaOverlay) return;
    window.clearTimeout(timer.current);
    timer.current = window.setTimeout(async () => {
      try {
        const { guidePrompt, prompt } = await previewPrompt(profile);
        setPrompt(guidePrompt || prompt);
      } catch (e) {
        setPrompt(`Preview failed: ${e instanceof Error ? e.message : e}`);
      }
    }, 400);
    return () => window.clearTimeout(timer.current);
  }, [profile]);

  return (
    <div className="prompt-preview">
      <p className="muted">
        This is the companion-specific prompt. Aura's fixed system rules (safety
        core, memory &amp; tool conduct) are always applied on top and cannot be
        changed per companion.
      </p>
      {prompt}
    </div>
  );
}
